import { useEffect } from "react";
import { store } from "../../appStore";

const EnvironmentRotationSetter = ({ yRotation = 0 }: { yRotation: number }) => {
  useEffect(() => {
    store.environmentRotation = yRotation;
  }, [yRotation]);

  return null;
};

export default EnvironmentRotationSetter;
